import { useFeatureFlagEnabled } from '@/app-shell/flags/posthog-compat';

/**
 * Kill switch for the T0–T5 modal tier framework (central R1–R5 enforcement at
 * the queue). PostHog, default OFF. Fed into `isModalTierFrameworkEnabledAtom`
 * by `ModalTierFrameworkSync`.
 *
 * Lives in its own leaf module (not the `index.tsx` barrel) so it doesn't add a
 * `react-refresh/only-export-components` warning to that `.tsx` file — the
 * ratchet blocks new ones. Import it directly from this path.
 */
export const useIsModalTierFrameworkEnabled = () => {
  return useFeatureFlagEnabled('release-growth-modal-tier-framework') ?? false;
};
